'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = 'M4.53 12.47a.75.75 0 0 0-1.06 1.06l5 5a.75.75 0 0 0 1.06 0l11-11a.75.75 0 0 0-1.06-1.06L9 16.94l-4.47-4.47z';